import { createPromiseClient } from '@bufbuild/connect-web';
import { transport } from '../transport';
import { ListRequest } from '@/generated/msh/service/v1/device_manager_pb';
import { DeviceManager } from '@/generated/msh/service/v1/device_manager_connectweb';

const client = createPromiseClient(DeviceManager, transport);

export async function fetchOfflineDevices(params, signal) {
  return await client.list(new ListRequest(params), { signal });
}
